// MainTopMenu.tsx
import { HorizontalLayout, VerticalLayout } from '../common/common-layout';
import BTBox from '../common/components/BTBox';
import { TitleNormalBold, TitleSmall } from '../common/common-text';
import { authStore } from '../store/AuthStore';
import BTButton from '../common/components/BTButton';
import theme from '../common/theme';
import TopItem1 from '../assets/icons/top_item_1.svg';

const MainTopMenu = () => {
  if (authStore.getIdToken() && authStore.user === null) {
    authStore.loadUserState();
  }

  const onMoveToAnalytics = () => {
    window.open(
      "https://analytics.google.com/analytics/web/?hl=ko#/p486863933/reports/intelligenthome",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <HorizontalLayout
      style={{
        alignItems: 'center',
        justifyContent: 'flex-start', // ← 좌측에서 시작
        height: '80px',
        gap: 16,                      // 보기 좋은 간격(선택)
      }}
      backgroundColor='white'
    >
      {/* 좌측 여백: 폭을 차지하도록 flex-grow 스페이서 사용 */}
      <div style={{ flex: 1, minWidth: 0 }} />

      {/* 우측 정보 묶음 */}
      <VerticalLayout wrapContents style={{ alignItems: 'flex-end' }}>
        <TitleNormalBold>{authStore.user?.username ?? ''}</TitleNormalBold>
        <BTBox height='4px' />
        <TitleSmall color='#8A92A6'>{authStore.user?.email ?? ''}</TitleSmall>
      </VerticalLayout>

      <BTBox width='24px' /> {/* 간격만 필요하면 이렇게 고정폭 박스 사용 */}

      <BTButton
        width='250px'
        color={theme.colors.bbTech}
        textColor="white"
        onClick={onMoveToAnalytics}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <img src={TopItem1} />
          <span>사이트 통계 관리로 이동</span>
        </span>
      </BTButton>

      <BTBox width='20px' />
    </HorizontalLayout>
  );
};

export default MainTopMenu;